import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { publicToolHead } from "@/lib/publicToolRoutes";

const Page = () => <Index toolKey="tips" routeLang="en" />;

export const Route = createFileRoute("/en/tips")({
  head: () => publicToolHead("tips", "en"),
  component: Page,
  errorComponent: Page,
  notFoundComponent: Page,
});
